
export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return "CaseCalendar"
}